import { getFeatureFlag } from 'src/app/core/services/feature-flag-helpers';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { TWhiteLabel } from '../white-label.model';
import { isChosenColor } from './is-chosen-color';
import {
  DEFAULT_ORIGINAL_PRIMARY_COLORS,
  DEFAULT_PRIMARY_COLORS,
} from './white-label-defaults.const';

function isOriginalBranding(primary950: string): boolean {
  return (
    Boolean(primary950) &&
    primary950.toLowerCase() === DEFAULT_ORIGINAL_PRIMARY_COLORS.primary950.toLowerCase()
  );
}

function isChosenPrimary600(primary600: string): boolean {
  return (
    isChosenColor(primary600, DEFAULT_ORIGINAL_PRIMARY_COLORS.primary600) &&
    isChosenColor(primary600, DEFAULT_PRIMARY_COLORS.primary600)
  );
}

export function resolvePrimary950(whiteLabelData: TWhiteLabel): string {
  if (!getFeatureFlag(EFeatureFlag.REBRAND)) {
    return whiteLabelData.primary600 || DEFAULT_ORIGINAL_PRIMARY_COLORS.primary600;
  }

  if (
    isOriginalBranding(whiteLabelData.primary950) &&
    isChosenPrimary600(whiteLabelData.primary600)
  ) {
    return whiteLabelData.primary600;
  }

  return whiteLabelData.primary950 || DEFAULT_PRIMARY_COLORS.primary950;
}
